(function () {
  const header = document.querySelector("[data-sticky-header]");
  if (!header) return;

  const SCROLL_THRESHOLD = 5;
  const TRANSITION = "transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)";

  let lastScrollY = window.scrollY;
  let isFixed = false;
  let isHidden = false;
  let ticking = false;
  let headerHeight = header.offsetHeight;

  // Spacer keeps layout stable when header becomes fixed
  const spacer = document.createElement("div");
  spacer.style.height = "0px";
  header.parentNode.insertBefore(spacer, header);

  const showHeader = () => {
    header.style.position = "fixed";
    header.style.top = "0";
    header.style.left = "0";
    header.style.right = "0";
    header.style.transition = TRANSITION;
    header.style.transform = "translateY(0)";
    header.style.boxShadow = "0 1px 3px 0 rgb(0 0 0 / 0.1)";
    spacer.style.height = `${headerHeight}px`;
    isFixed = true;
    isHidden = false;
  };

  const hideHeader = () => {
    header.style.transition = TRANSITION;
    header.style.transform = "translateY(-100%)";
    header.style.boxShadow = "";
    isHidden = true;
  };

  const resetHeader = () => {
    header.style.position = "";
    header.style.top = "";
    header.style.left = "";
    header.style.right = "";
    header.style.transition = "";
    header.style.transform = "";
    header.style.boxShadow = "";
    spacer.style.height = "0px";
    isFixed = false;
    isHidden = false;
  };

  const update = () => {
    const currentScrollY = window.scrollY;
    headerHeight = header.offsetHeight;

    // At the top — reset to natural position
    if (currentScrollY <= headerHeight) {
      if (isFixed) resetHeader();
      lastScrollY = currentScrollY;
      ticking = false;
      return;
    }

    const delta = currentScrollY - lastScrollY;

    // Scrolling down — hide
    if (delta > SCROLL_THRESHOLD) {
      if (!isFixed) {
        // Jump straight to hidden-fixed so there's no flash
        header.style.position = "fixed";
        header.style.top = "0";
        header.style.left = "0";
        header.style.right = "0";
        header.style.transition = "none";
        header.style.transform = "translateY(-100%)";
        header.style.boxShadow = "";
        spacer.style.height = `${headerHeight}px`;
        isFixed = true;
        isHidden = true;
      } else if (!isHidden) {
        hideHeader();
      }
      lastScrollY = currentScrollY;
    }

    // Scrolling up — reveal
    if (delta < -SCROLL_THRESHOLD) {
      if (!isFixed) {
        // Snap to hidden-fixed first, then animate in
        header.style.position = "fixed";
        header.style.top = "0";
        header.style.left = "0";
        header.style.right = "0";
        header.style.transition = "none";
        header.style.transform = "translateY(-100%)";
        spacer.style.height = `${headerHeight}px`;
        isFixed = true;
        // Force reflow so the browser registers the -100% state
        header.offsetHeight;
      }
      if (isHidden || !isFixed) {
        showHeader();
      }
      lastScrollY = currentScrollY;
    }

    ticking = false;
  };

  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    headerHeight = header.offsetHeight;
    if (isFixed) spacer.style.height = `${headerHeight}px`;
  });
})();
